import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Modal,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import {
  EnvelopeFill,
  TelephoneFill,
  Linkedin,
  ChatDotsFill,
} from "react-bootstrap-icons";
import "./contact.css";

const Contact = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState({
    success: false,
    message: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };



  const sendMail = async (templateId, templateParams) => {
    return fetch("https://api.emailjs.com/api/v1.0/email/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        service_id: process.env.REACT_APP_EMAILJS_SERVICE_ID,
        template_id: templateId,
        user_id: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
        template_params: templateParams,
      }),
    });
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);

    try {
      // Admin email
      const admin = await sendMail(
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          to_email: "puthaplnrao@gmail.com",
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          message: formData.message,
          reply_to: formData.email,
        }
      );

      if (!admin.ok) {
        throw new Error("Failed to send admin email");
      }

      // Auto reply to user
      const autoReply = await sendMail(
        process.env.REACT_APP_EMAILJS_AUTOREPLY_TEMPLATE_ID,
        {
          to_email: formData.email,
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }
      );

      if (!autoReply.ok) {
        throw new Error("Failed to send auto reply");
      }

      setResult({
        success: true,
        message: "Message sent successfully!",
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setTimeout(() => {
  closeModal();
}, 1500);
    } catch (err) {
      console.error(err);

      setResult({
        success: false,
        message: "Failed to send email.",
      });
    }

    setLoading(false);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      valid = false;
    } else if (!/^[A-Za-z ]+$/.test(formData.name)) {
      newErrors.name = "Only alphabets are allowed";
      valid = false;
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid email";
      valid = false;
    }

    // Phone
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
      valid = false;
    } else if (
      !/^\+?[0-9\s()-]{7,20}$/.test(formData.phone)
    ) {
      newErrors.phone = "Enter a valid phone number";
      valid = false;
    }

    // Message
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
      valid = false;
    } else if (formData.message.trim().length < 15) {
      newErrors.message = "Message must contain at least 15 characters";
      valid = false;
    }

    setErrors(newErrors);

    return valid;
  };

  const closeModal = () => {
  setShowModal(false);

  setFormData({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  setErrors({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  setResult({
    success: false,
    message: "",
  });

  setLoading(false);
};

  return (
    <section id="contact" className="py-4">
      <Container>
        <h2 className="mb-4">Contact Me</h2>

        <Row className="justify-content-center">

          <Col md={3} className="mb-4">
            <Card className="contact-card text-center">
              <Card.Body>
                <div className="contact-icon">
                  <TelephoneFill size={30} />
                </div>
                <Card.Title>Phone</Card.Title>
                <Card.Text>
                  <a
                    href="tel:+919573188288"
                    className="text-decoration-none"
                  >
                    +91 95731 88288
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-4">
            <Card className="contact-card text-center">
              <Card.Body>
                <div className="contact-icon">
                  <EnvelopeFill size={30} />
                </div>
                <Card.Title>Email</Card.Title>
                <Card.Text>
                  <a
                    href="mailto:puthaplnrao@gmail.com"
                    className="text-decoration-none"
                  >
                    puthaplnrao@gmail.com
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-4">
            <Card className="contact-card text-center">
              <Card.Body>
                <div className="contact-icon">
                  <Linkedin size={30} />
                </div>
                <Card.Title>LinkedIn</Card.Title>
                <Card.Text>
                  <a
                    href="https://www.linkedin.com/in/puthaplnrao"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    linkedin.com/in/puthaplnrao
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3} className="mb-4">
            <Card
              className="contact-card text-center"
              style={{ cursor: "pointer" }}
              onClick={() => setShowModal(true)}
            >
              <Card.Body>
                <div className="contact-icon">
                  <ChatDotsFill size={30} />
                </div>
                <Card.Title>Send Message</Card.Title>
                <Card.Text className="text-primary">
                  Click here
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <Modal
  show={showModal}
  onHide={closeModal}
  centered
>
          <Modal.Header closeButton>
            <Modal.Title>Send Message</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {result.message && (
              <Alert
                variant={result.success ? "success" : "danger"}
              >
                {result.message}
              </Alert>
            )}

            <Form onSubmit={sendEmail}>

              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>

                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                  placeholder="Enter your name"
                />

                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>

                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                  placeholder="Enter your email"
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>

                <Form.Control
                  type="tel"
                  name="phone"
                  maxLength={20}
                  value={formData.phone}
                  onChange={(e) => {
  const value = e.target.value.replace(/[^0-9+() -]/g, "");

  handleChange({
    target: {
      name: "phone",
      value,
    },
  });
}}
                  isInvalid={!!errors.phone}
                  placeholder="Enter phone number"
                />

                <Form.Control.Feedback type="invalid">
                  {errors.phone}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  isInvalid={!!errors.message}
                  placeholder="Type your message..."
                />

                <Form.Control.Feedback type="invalid">
                  {errors.message}
                </Form.Control.Feedback>

                <div className="text-end text-secondary mt-1">
                  {formData.message.length}/500
                </div>

              </Form.Group>



              <div className="d-flex justify-content-end">

<Button
  className="contact-btn-secondary me-2"
  onClick={closeModal}
>
  Cancel
</Button>

<Button
  className="contact-btn-primary"
  type="submit"
  disabled={loading}
>
  {loading ? "Sending..." : "Send Message"}
</Button>

              </div>

            </Form>

          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default Contact;